import React, { createContext, useEffect, useState } from "react";

import CircleLoader from "react-spinners/CircleLoader";

import apiAutenticacao from "../services/api-autenticacao.service";
import appStyles from "./sytles.module.css";
import { Token } from "../utils/localStorage.util";
import { AuthServices } from "../services/auth.service";

const Context = createContext();

function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getLogin = async () => {
      const token = Token.getToken();
      if (token) {
        setAuthenticated(true);
        apiAutenticacao.defaults.headers.Authorization = `${token}`;
      } else {
        handleLogout();
      }
      setLoading(false);
    };
    getLogin();
  }, []);

  function handleLogout() {
    setAuthenticated(false);
    AuthServices.logout();
    apiAutenticacao.defaults.headers.Authorization = null;
  }

  async function signIn(loginResponse) {
    setAuthenticated(true);
    AuthServices.login(loginResponse);
    apiAutenticacao.defaults.headers.Authorization = `${loginResponse.token}`;
  }

  return (
    <React.Fragment>
      {
        (loading)
        ? (
          <div className={appStyles.spinnerContainer} >
            <CircleLoader
              color="#FFFFFF"
              loading={loading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        )
        : (
          <Context.Provider value={{ authenticated, signIn, handleLogout }}>
            {children}
          </Context.Provider>
        )
      }

    </React.Fragment>
  );
}

export { Context, AuthProvider };
